export enum EMailKind {
  UNBEKANNT = 'UNBEKANNT',
  EINGEHEND = 'EINGEHEND',
  EINGEHEND_HTML = 'EINGEHEND_HTML',
  AUSGEHEND = 'AUSGEHEND',
  ENTWURF_HTML = 'ENTWURF_HTML',
  ENTWURF = 'ENTWURF',
}
